import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';
import HtmlParser from 'react-html-parser';

import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';
import { receiptModelGet } from '../../models/receipts/receipt';
import BuildingHeader from '../buildings/BuildingHeader';
import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, setBadgeStatus, separatorsNumbersSet, styles, sendMessageCloseCurrentWindowAsync,
    dateTimeFormatGlobalSet, buttonProcessGet, awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';

import Menu from '../main/Menu';
import ExpenseTemplateAdd from './ExpenseTemplateAdd';
import Swal from 'sweetalert2';

import moment from 'moment-timezone';
import 'react-tempusdominus-bootstrap';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { validationExpenseTemplateGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { expenseTemplateModelGet } from '../../models/expenses/template';
import { apartmentReceiptDetailModelGet } from '../../models/apartments/apartmentReceiptDetail';
import ReceiptsVariations from './ReceiptsVariations';

const currentMethod = 'ReceiptsGenerate';

//const { app, collections: dbColle, icons, labels, messages, react, } = globalSettings;
const { app, collections: dbColle, icons, labels, messages, react } = globalSettings;
const { properties: dbProps, } = dbColle;
const { html: reactHtml, sweetAlert2, } = react;
const { operators: dbOpera, } = react?.firebase;
const { backend, } = app;

export default function ReceiptsGenerate({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let headerObj = {};
    let dataObj = {};
    let swalProperties = {};
    const auth = useAuth();
    const neutralValue = 0.00;
    //const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [processType, setProcessType] = useState(-1);
    const [isEditabled, setIsEditabled] = useState(false);
    //const inputDescriptionId = 'inputDescription';
    const [showLoading, setShowLoading] = useState({ building: true, receipts: true, receipt: true, });
    //const [showData, setShowData] = useState(false);
    const [isEditDelete, setIsEditDelete] = useState(false);
    //#endregion variables

    //#region receipts
    let receipts = [];
    const dtReceiptsId = 'dtReceipts';
    const [dtReceiptsRowIndex, setDtReceiptsRowIndex] = useState(0);
    const [receiptsSyncDisabled, setReceiptsSyncDisabled] = useState(true);
    const [apartmentReceiptDetailsBalance, setApartmentReceiptDetailsBalance] = useState(neutralValue);
    const [receiptsVariationsShowModal, setReceiptsVariationsShowModal] = useState(false);
    const [receiptsVariations, setReceiptsVariations] = useState([{
        ...receiptModelGet({}),
        price: neutralValue,
        details: {
            price: neutralValue,
        },
        percentage: neutralValue,
    }]);
    //#endregion receipts

    //#region receipt
    const dateFromId = 'dateFromId';
    //const receiptFromInputId = 'receiptFromInput';
    const dateToId = 'dateToId';
    //const receiptToInputId = 'receiptToInput';
    const [receipt, setReceipt] = useState(receiptModelGet({}));
    const [descriptionError, setDescriptionError] = useState('');
    const [expenseTemplateError, setExpenseTemplateError] = useState('');
    const [dateFromError, setDateFromError] = useState('');
    const [dateToError, setDateToError] = useState('');
    //#endregion receipt

    //#region buildings
    const buildingsId = 'buildingsId'
    //const [buildingId, setBuildingId] = useState('');
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    //const [buildingEmail, setBuildingEmail] = useState('');
    //const [buildingContract, setBuildingContract] = useState('');

    //#endregion buildings

    //#region expenseTemplate
    const [expenseTemplate, setExpenseTemplate] = useState(expenseTemplateModelGet({}));
    const [expenseTemplatesDt, setExpenseTemplatesDt] = useState([]);
    const [expenseTemplates, setExpenseTemplates] = useState([expenseTemplateModelGet({})]);
    const [expenseTemplateAddShowModal, setExpenseTemplateAddShowModal] = useState(false);
    //#endregion expenseTemplate

    //#region others
    const controls = {
        buttons: {
            expenseTemplateAdd: {
                id: 'btnExpenseTemplateAdd',
                className: 'btn btn-outline-primary mx-1',
            },
            save: {
                id: 'btnSave',
                className: 'btn btn-outline-primary mx-1',
            },
            new: {
                id: 'btnNew',
                className: 'btn btn-outline-success',
            },
            open: {
                id: 'btnOpen',
                className: 'btn btn-outline-warning mx-1',
            },
            close: {
                id: 'btnClose',
                className: 'btn btn-outline-info',
            },
            delete: {
                id: 'btnDelete',
                className: 'btn btn-outline-danger mx-1',
            },
            variations: {
                id: 'btnVariations',
                className: 'btn btn-outline-secondary mx-1',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            receipts: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm mx-1',
                    //     id: 'btnDtSuppliersCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtSuppliersCreate',
                    //     className: icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtReceiptsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtReceiptsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtSuppliersCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            expenseTemplateAdd: {
                id: 'icoExpenseTemplateAdd',
                className: icons?.search,
            },
            save: {
                id: 'icoSave',
                className: icons?.save,
            },
            new: {
                id: 'icoNew',
                className: icons?.fileAltFar,
            },
            open: {
                id: 'icoOpen',
                className: icons?.fasFa?.lockOpen,
            },
            close: {
                id: 'icoClose',
                className: icons?.fasFa?.lok,
            },
            delete: {
                id: 'icoDelete',
                className: icons?.trash,
            },
            variations: {
                id: 'icoVariations',
                className: icons?.chartLine,
            },
        },
        inputs: {
            number: {
                id: 'inputNumber',
                //className: 'form-control bg-transparent text-black',
                className: 'form-control',
            },
            description: {
                id: 'inputDescription',
                //className: 'form-control bg-transparent text-black',
                className: 'form-control',
            },
            dateFrom: {
                id: 'inputDateFrom',
                //className: 'form-control bg-transparent text-black datetimepicker-input',
                className: 'form-control datetimepicker-input',
            },
            dateTo: {
                id: 'inputDateTo',
                //className: 'form-control bg-transparent text-black datetimepicker-input',
                className: 'form-control datetimepicker-input',
            },
            expenseTemplateDescription: {
                id: 'inputExpenseTemplateDescription',
                //className: 'form-control bg-transparent text-black',
                className: 'form-control',
            },
            expenseTemplateBalance: {
                id: 'inputExpenseTemplateBalance',
                //className: 'form-control bg-transparent text-black text-right',
                className: 'form-control text-right',
            },
            apartmentReceiptDetailsBalance: {
                id: 'inputApartmentReceiptDetailsBalance',
                //className: 'form-control bg-transparent text-black text-right',
                className: 'form-control text-right',
            },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            expenseTemplateAdd: {
                id: 'spExpenseTemplateAdd',
                className: '',
            },
            save: {
                id: 'spSave',
                className: '',
            },
            new: {
                id: 'spNew',
                className: '',
            },
            open: {
                id: 'spOpen',
                className: '',
            },
            close: {
                id: 'spClose',
                className: '',
            },
            delete: {
                id: 'spDelete',
                className: '',
            },
            variations: {
                id: 'spVariations',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region receipt (methods)
    const dataTableReceiptsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableReceiptsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtReceiptsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.receipt?.[languageObj?.id], width: '5%', },
                    { title: labels?.description?.[languageObj?.id], width: '45%', },
                    { title: labels?.status?.[languageObj?.id], className: 'text-center', width: '10%', },
                    { title: labels?.balance?.[languageObj?.id], className: 'text-right', width: '15%', },
                    { title: labels?.from?.[languageObj?.id], width: '10%', },
                    { title: labels?.to?.[languageObj?.id], width: '10%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtReceiptsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const receiptsGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'receiptsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            setShowLoading({ building: false, receipts: true, receipt: true, });

            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let buildingLocal = buildingModelGet({});
            let receiptsLocal = [receiptModelGet({})];
            let buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            //#region initialize
            //#region old code
            // if (!isUndNullEmp({data: e, subMethod: currentMethod, })?.result) {
            //     buildingIdLocal = e?.target?.value;
            //     setBuildingId(buildingIdLocal);
            // } else {
            //     buildingIdLocal = buildingId;
            // }
            //#endregion old code

            setProcessType(-1);
            setIsEditabled(false);
            setIsEditDelete(false);
            setExpenseTemplate({});
            setDtReceiptsRowIndex(0);
            setReceiptsSyncDisabled(true);
            setReceipt(receiptModelGet({
                buildingId: buildingIdLocal,
                expenseTemplateId: '',
                receiptGenerateds: 0,
                userId: auth?.user?.uid,
            }));
            setApartmentReceiptDetailsBalance(neutralValue);
            //#endregion initialize

            $(`#${dtReceiptsId}`)?.DataTable()?.rows()?.clear()?.draw(true);

            //#region error default set
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, });
                return;
            }
            //#endregion error default set

            //#region dateTime in control set
            response = await dateInControlSetAsync({
                date: new Date(),
                receiptDateFrom: undefined,
                receiptDateTo: undefined,
                type: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, });
                return;
            }
            //#endregion dateTime in control set

            //#region receipts get
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                //#region receipts get data
                buildingLocal = buildings?.find(({ id, }) => id === buildingIdLocal);
                setBuilding(buildingLocal);

                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };

                dataObj = {
                    conditionals: [
                        { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, },
                    ],
                    ordersBy: [
                        { field: dbProps?.number, value: 'asc' },
                    ],
                    buildingId: buildingIdLocal,
                    languageId: languageObj?.id,
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result.data;

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, receipts: false, receipt: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                receiptsLocal = response?.result || [];
                //#endregion receipts get data

                if (!isUndNullEmp({ data: receiptsLocal, subMethod: currentMethod, })?.result && receiptsLocal?.length > 0) {
                    receiptsLocal?.forEach((detail) => {
                        //#region variables
                        const dataRowObj = {
                            number: detail?.number,
                            description: detail?.description,
                            status: setBadgeStatus({
                                type: detail?.isOpen ? 0 : 1,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            }),
                            balance: separatorsNumbersSet({
                                number: detail?.balance,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result,
                            from: dateTimeFormatGlobalSet({
                                date: detail?.from,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            to: dateTimeFormatGlobalSet({
                                date: detail?.to,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                        };
                        //#endregion variables

                        //#region methods
                        dtRows?.push([
                            //#region old code
                            // detail?.number,
                            // detail?.description,
                            // setBadgeStatus({
                            //     type: detail?.isOpen ? 0 : 1,
                            //     languageId: languageObj?.id,
                            //     subMethod: currentMethod,
                            // }),
                            // separatorsNumbersSet(detail?.balance).result,
                            // dateTimeFormatGlobalSet(detail?.from, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                            // dateTimeFormatGlobalSet(detail?.to, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                            //#endregion old code
                            dataRowObj?.number,
                            dataRowObj?.description,
                            dataRowObj?.status,
                            dataRowObj?.balance,
                            dataRowObj?.from,
                            dataRowObj?.to,
                            buttonProcessGet({
                                id: detail?.id,
                                description: detail?.description,
                                showDetails: true,
                                labelDetails: labels?.detail?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: false,
                                labelEdit: labels?.edit?.[languageObj?.id],
                                enabledEdit: false,
                                showDelete: false,
                                labelDelete: labels?.delete?.[languageObj?.id],
                                enabledDelete: false,
                                processButtons: [],
                                subMethod: currentMethod,
                            })?.result,
                        ]);
                        //#endregion methods
                    });
                }

                setProcessType(0);
                setIsEditabled(true);
                //#region old code
                //setReceipt(receiptModelGet(buildingIdLocal, '', 0, auth?.user?.uid,));
                //#endregion old code
                setReceiptsSyncDisabled(false);

                //#region set if edit, delete data
                isEditLocal = processEvaluateGet({
                    object: buildingLocal,
                    property: labels?.process?.en?.toLowerCase(),
                    process: labels?.edit?.en?.toLowerCase(),
                    subMethod: currentMethod
                })?.result;
                isDeleteLocal = isEditLocal;
                setIsEditDelete(!(isEditLocal && isDeleteLocal));
                //#endregion set if edit, delete data

                $(`#${dtReceiptsId}`)?.DataTable()?.rows?.add(dtRows)?.draw();
            } else {
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            }
            //#endregion receipts get

            //#region old code
            //#region dataTable set / clear datatabla / set query code / set data in datatable
            //#region old code
            // response = dataTableReceiptsSetAsync();
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading({ building: false, receipts: false, receipt: false, });

            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return
            // }
            //#endregion old code

            //#region old code
            // response = queryCodeSetAsync();
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading({ building: false, receipts: false, receipt: false, });

            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return
            // }
            //#endregion old code

            //#region old code
            // response = localDataTablesClear(true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading({ building: false, receipts: false, receipt: false, });

            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return
            // }
            //#endregion old code

            //#region old code
            //$(`#${dtReceiptsId}`)?.DataTable()?.rows?.add(receiptsDataLocal)?.draw();
            //#endregion old code
            //#endregion dataTable set / clear datatabla / set query code / set data in datatable
            //#endregion old code

            setShowLoading({ building: false, receipts: false, receipt: false, });
        } catch (ex) {
            setShowLoading({ building: false, receipts: false, receipt: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setReceipt({ ...receipt, [property]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const receiptAddGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'receiptAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            const buildingObjLocal = $(`#${buildingsId}`);
            const buildingIdLocal = buildingObjLocal?.val();
            //#endregion variables

            //#region initialize
            setApartmentReceiptDetailsBalance(neutralValue);
            //#endregion initialize

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });

            //#region datInControl set
            response = await dateInControlSetAsync({
                date: new Date(),
                receiptDateFrom: undefined,
                receiptDateTo: undefined,
                processType: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }
            //#endregion datInControl set

            //#region error default set
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion error default set

            setExpenseTemplate({});
            setExpenseTemplates([]);

            //#region type check
            if (processType === -1) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.thisProcessAppliesOnlyToNewOrCreatedRecords?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion type check

            //#region buildingId check
            if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                buildingObjLocal?.trigger('focus');
                return;
            }
            //#endregion buildingId check

            //#region data set
            setProcessType(0);
            setIsEditabled(true);
            setReceipt(
                receiptModelGet({
                    buildingId: buildingIdLocal,
                    expenseTemplateId: '',
                    receiptGenerateds: 0,
                    userId: auth?.user?.uid,
                })
            );
            $(`#${controls?.inputs?.description?.id}`)?.trigger('focus');
            //#endregion data set

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const receiptAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'receiptAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let receiptLocal = receiptModelGet({});
            //#endregion variables

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await receiptDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });

            //#region receipt add
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                receipt: receipt,
                languageCode: languageObj?.code,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            receiptLocal = response?.result?.receipt || {};
            //#endregion receipt add

            //#region add receipt (DataTable)
            //#region variables
            const dataRowObj = {
                number: receiptLocal?.number,
                description: receiptLocal?.description,
                status: setBadgeStatus({
                    type: receiptLocal?.isOpen ? 0 : 1,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                }),
                balance: separatorsNumbersSet({
                    number: receiptLocal?.balance,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                from: dateTimeFormatGlobalSet({
                    date: receiptLocal?.from,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                to: dateTimeFormatGlobalSet({
                    date: receiptLocal?.to,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
            };
            //#endregion variables

            //#region methods
            $(`#${dtReceiptsId}`)?.DataTable()?.row?.add([
                //receiptLocal.number,
                dataRowObj?.number,
                //receiptLocal.description,
                dataRowObj?.description,
                //setBadgeStatus(0),
                dataRowObj?.status,
                //separatorsNumbersSet(receiptLocal.balance).result,
                dataRowObj?.balance,
                //dateTimeFormatGlobalSet(receiptLocal.from, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                dataRowObj?.from,
                //dateTimeFormatGlobalSet(receiptLocal.to, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                dataRowObj?.to,
                buttonProcessGet({
                    id: receiptLocal.id,
                    description: receiptLocal.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods
            //#endregion add receipt (DataTable)

            //#region form new set
            response = await dateInControlSetAsync({
                date: new Date(),
                receiptDateFrom: undefined,
                receiptDateTo: undefined,
                processType: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }

            //#region error default set
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }
            //#endregion error default set

            setProcessType(0);
            setIsEditabled(true);
            setExpenseTemplate({});
            setReceipt(
                receiptModelGet({
                    buildingId: $(`#${buildingsId}`).val(),
                    expenseTemplateId: '',
                    receiptGenerateds: 0,
                    userId: auth?.user?.uid,
                })
            );
            $(`#${controls?.inputs?.description?.id}`)?.trigger('focus');
            //#endregion form new set

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            //#region final message
            response.msgText = `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}<br/>`;
            response.msgText += `${labels?.number?.[languageObj?.id]}: <b>${receiptLocal?.number}</b><br/>`;
            response.msgText += `${labels?.receipts?.[languageObj?.id]}: <b>${receiptLocal?.receiptGenerateds}</b>`;

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            //#endregion final message
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const receiptEditGetAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'receiptEditGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let receiptLocal = receiptModelGet({});
            let expenseTemplateLocal = expenseTemplateModelGet({});
            let apartmentReceiptDetailsLocal = [apartmentReceiptDetailModelGet({})];
            //#endregion variables

            setShowLoading({ building: false, receipts: false, receipt: true, });

            //#region initialize
            setReceipt(receiptLocal);
            setExpenseTemplate(expenseTemplateLocal);
            setApartmentReceiptDetailsBalance(neutralValue);
            await dateInControlSetAsync({
                date: new Date(),
                receiptDateFrom: undefined,
                receiptDateTo: undefined,
                processType: 1,
                subMethod: currentMethod,
            });
            //#endregion initialize

            //#region error default set
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, });
                return;
            }
            //#endregion error default set

            //#region data get (receipt)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            receiptLocal = response?.result?.receipt || {};
            //#endregion data get (receipt)

            //#region data get (expense template)
            //#region old code

            // //result = await axios?.get(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlExpenseTemplates}/${localReceipt.expenseTemplateId}`, headerObj);
            // result = await axios?.get(`${backend?.url}${backend?.urlApiV1}${backend?.urlExpenseTemplates}/${localReceipt.expenseTemplateId}`, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // localExpenseTemplate = response.result;

            //#endregion old code

            expenseTemplateLocal = response?.result?.expenseTemplate || {};
            //#endregion data get (expense template)

            //#region data get (apartment receipt details)
            apartmentReceiptDetailsLocal = response?.result?.apartmentReceiptDetails || [];
            setApartmentReceiptDetailsBalance(
                !isUndNullEmp({ data: apartmentReceiptDetailsLocal, subMethod: currentMethod, })?.result && apartmentReceiptDetailsLocal.length > 0 ?
                    !isUndNullEmp({ data: apartmentReceiptDetailsLocal?.[0]?.totalGeneral, subMethod: currentMethod, })?.result ?
                        apartmentReceiptDetailsLocal?.[0]?.totalGeneral :
                        neutralValue :
                    neutralValue
            );
            //#endregion data get (apartment receipt details)

            //#region data set
            setProcessType(1);
            setReceipt(receiptLocal);
            setDtReceiptsRowIndex(rowIndex);
            setIsEditabled(receiptLocal?.isOpen);
            setExpenseTemplate(expenseTemplateLocal);

            response = await dateInControlSetAsync({
                date: new Date(),
                receiptDateFrom: receiptLocal?.from,
                receiptDateTo: receiptLocal?.to,
                processType: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, });
                return;
            }
            //#endregion data set

            setShowLoading({ building: false, receipts: false, receipt: false, });
        } catch (ex) {
            setShowLoading({ building: false, receipts: false, receipt: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const receiptEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'receiptEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let receiptLocal = receiptModelGet({});
            //#endregion variables

            //#region initialize
            //#region error default set
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion error default set

            //#region receipt data set
            response = await receiptDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion receipt data set

            //#region form data validate
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate
            //#endregion initialize

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });

            //#region updare receipt
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                receipt: receipt,
                languageCode: languageObj?.code,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            receiptLocal = response?.result?.receipt || {};
            setReceipt(receiptLocal);
            //#endregion updare receipt

            //#region add receipt (DataTable)
            //#region variables
            const dataRowObj = {
                number: receiptLocal?.number,
                description: receiptLocal?.description,
                status: setBadgeStatus({
                    type: receiptLocal?.isOpen ? 0 : 1,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                }),
                balance: separatorsNumbersSet({
                    number: receiptLocal?.balance,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                from: dateTimeFormatGlobalSet({
                    date: receiptLocal?.from,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                to: dateTimeFormatGlobalSet({
                    date: receiptLocal?.to,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
            };
            //#endregion variables

            //#region methods
            $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
                //receiptLocal.number,
                dataRowObj?.number,
                //receiptLocal.description,
                dataRowObj?.description,
                //setBadgeStatus(receiptLocal.isOpen ? 0 : 1),
                dataRowObj?.status,
                //separatorsNumbersSet(receiptLocal.balance).result,
                dataRowObj?.balance,
                //dateTimeFormatGlobalSet(receiptLocal.from, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                dataRowObj?.from,
                //dateTimeFormatGlobalSet(receiptLocal.to, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                dataRowObj?.to,
                buttonProcessGet({
                    id: receiptLocal?.id,
                    description: receiptLocal?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods
            //#endregion add receipt (DataTable)

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const receiptDeleteGetAsync = async (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         e?.preventDefault();

    //         if (processType !== 1 || isNull(receipt) || isUndefined(receipt)) {
    //             sendMessage(1, messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id], 0, true, false, null, '');
    //             return;
    //         }

    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         if (processType === 1) {
    //             response.msgText = `${labels?.receipt?.[languageObj?.id]}: <b>${receipt.description}</b><br/>`;
    //             response.msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //             swalProperties = {
    //                 icon: sweetAlert2?.icons?.warning,
    //                 title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //                 html: response.msgText,
    //                 timer: null,
    //                 confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //                 confirmButtonText: labels?.yes?.[languageObj?.id],
    //                 showCancelButton: true,
    //                 cancelButtonColor: globalSettings?.colors?.successColorExp,
    //                 cancelButtonText: labels?.no?.[languageObj?.id],
    //                 didOpen: () => {
    //                     Swal.hideLoading();
    //                 },
    //             };

    //             const { isConfirmed, } = await Swal.fire(swalProperties);
    //             if (isConfirmed) {
    //                 receiptDeleteAsync();
    //             }
    //         } else {
    //             sendMessage(1, messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id], 0, true, false, null, '');
    //             return;
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: receiptDeleteGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //     }
    // }
    //#endregion old code

    const receiptDeleteAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'receiptDeleteAsync';
        let response = responseGet();
        try {
            //#region old ode
            // sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            // //#region receipt delete

            // headerObj = {
            //     headers: {
            //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //     },
            // };

            // //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt.id}`, headerObj);
            // result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt.id}`, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // //#endregion receipt delete

            // //#region dataTable receipts

            // $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.remove()?.draw(true);
            // receipts = receipts.filter(({ id }) => id !== receipt.Id);

            // //#endregion dataTable receipts

            // //#region set receipt new

            // setReceipt(receiptModelGet($(`#${buildingsId}`).val(), '', 0, auth?.user?.uid));
            // setExpenseTemplate({});

            // response = dateInControlSetAsync(new Date(), null, null, 1);
            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // setProcessType(0);
            // setIsEditabled(true);

            // //#endregion set receipt new

            // sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            //#endregion old ode

            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region ststuc check
            if (processType !== 1 || isUndNullEmp({ data: receipt?.id, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion ststuc check

            //#region show message
            let msgTextObj = {
                one: `${labels?.receipt?.[languageObj?.id]}: <b>${receipt?.number}</b><br/>`,
                two: `${labels?.description?.[languageObj?.id]}: <b>${receipt?.description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region receipt delete
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageCode: languageObj?.code,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt.id}`,
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion receipt delete

                        //#region dataTable receipts
                        $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.remove()?.draw(true);
                        receipts = receipts.filter(({ id }) => id !== receipt?.Id);
                        //#endregion dataTable receipts

                        //#region set receipt new
                        setProcessType(0);
                        setIsEditabled(true);
                        setExpenseTemplate({});
                        setReceipt(
                            receiptModelGet({
                                buildingId: $(`#${buildingsId}`).val(),
                                expenseTemplateId: '',
                                receiptGenerateds: 0,
                                userId: auth?.user?.uid,
                            })
                        );
                        setApartmentReceiptDetailsBalance(neutralValue);
                        response = await dateInControlSetAsync({
                            date: new Date(),
                            receiptDateFrom: undefined,
                            receiptDateTo: undefined,
                            processType: 1,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            return;
                        }
                        //#endregion set receipt new

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const receiptCloseGetAsync = async (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         e?.preventDefault();

    //         if (processType !== 1) {
    //             sendMessage(1, messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id], 0, true, false, null, '');
    //             return;
    //         }

    //         response.msgText = `${messages?.closeReceiptMessages?.[languageObj?.id]}<br/>`;
    //         response.msgText += `${labels?.receipt?.[languageObj?.id]}: <b>${receipt.number}</b><br/>`;
    //         response.msgText += `${messages?.doYouWishContinue?.[languageObj?.id]}`;

    //         swalProperties = {
    //             icon: sweetAlert2?.icons?.warning,
    //             title: labels?.warning?.[languageObj?.id],
    //             html: response.msgText,
    //             timer: null,
    //             confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: globalSettings?.colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);
    //         if (isConfirmed) {
    //             receiptCloseAsync();
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: receiptCloseGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //     }
    // }
    //#endregion old code

    const receiptCloseAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'receiptCloseAsync';
        let response = responseGet();
        try {
            //#region old code
            // //#region variables
            // let localReceipt = {};
            // //#endregion variables

            // //#region initialize
            // //#region error default set

            // response = errosDefaultSetAsync();
            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // //#endregion error default set

            // //#region receipt data set

            // response = receiptDataSetAsync();
            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // //#endregion receipt data set

            // //#region form data validate

            // response = formDataValidateAsync()
            // if (!response?.isSuccess || response?.isWarning) {
            //     return;
            // }

            // //#endregion form data validate
            // //#endregion initialize

            // sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            // //#region check if the receipt is closed

            // response = await receiptCheckOpenCloseGetAsync(receipt.id, 1, true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // //#endregion check if the receipt is closed

            // //#region updare receipt
            // receipt.isOpen = false;
            // receipt.isClose = true;
            // receipt.isCloseDate = new Date()?.toISOString();

            // headerObj = {
            //     headers: {
            //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //     },
            // };

            // //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt.id}`, receipt, headerObj);
            // result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt.id}`, receipt, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // localReceipt = response.result.receipt;
            // setReceipt(localReceipt);
            // setIsEditabled(false);

            // //#endregion updare receipt

            // //#region add receipt (DataTable)

            // $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
            //     localReceipt.number,
            //     localReceipt.description,
            //     setBadgeStatus(localReceipt.isOpen ? 0 : 1),
            //     separatorsNumbersSet(localReceipt.balance).result,
            //     dateTimeFormatGlobalSet(localReceipt.from, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
            //     dateTimeFormatGlobalSet(localReceipt.to, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
            //     buttonProcessGet(
            //         localReceipt.id,
            //         localReceipt.description,
            //         true,
            //         labels?.detail?.[languageObj?.id],
            //         true,
            //         false,
            //         labels?.edit?.[languageObj?.id],
            //         false,
            //         false,
            //         labels?.delete?.[languageObj?.id],
            //         false,
            //         []
            //     ).result,
            // ])?.draw(true);

            // //#endregion add receipt (DataTable)

            // sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            //#endregion old code

            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region ststuc check
            if (processType !== 1) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion ststuc check

            //#region variables
            let receiptLocal = receiptModelGet({});
            //#endregion variables

            //#region initialize
            //#region error default set
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion error default set

            //#region receipt data set
            response = await receiptDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion receipt data set

            //#region form data validate
            response = await formDataValidateAsync({ subMethod: currentMethod, })
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate
            //#endregion initialize

            //#region show message
            let msgTextObj = {
                one: `${messages?.closeReceiptMessages?.[languageObj?.id]}<br/>`,
                two: `${labels?.receipt?.[languageObj?.id]}: <b>${receipt?.number}</b><br/>`,
                three: `${labels?.description?.[languageObj?.id]}: <b>${receipt?.description}</b><br/>`,
                four: `${messages?.doYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                //title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                title: labels?.warning?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}${msgTextObj?.four}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                            showConfirmButton: false,
                        });

                        //#region check if the receipt is closed
                        response = await receiptCheckOpenCloseGetAsync({
                            receiptId: receipt?.id,
                            processType: 1,
                            checkStatus: true,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion check if the receipt is closed

                        //#region updare receipt
                        receipt.isOpen = false;
                        receipt.isClose = true;
                        receipt.isCloseDate = new Date()?.toISOString();

                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };
                        dataObj = {
                            receipt: receipt,
                            languageCode: languageObj?.code,
                            languageId: languageObj?.id,
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt?.id}`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        receiptLocal = response?.result?.receipt || {};
                        setReceipt(receiptLocal);
                        setIsEditabled(false);
                        //#endregion updare receipt

                        //#region add receipt (DataTable)
                        //#region variables
                        const dataRowObj = {
                            number: receiptLocal?.number,
                            description: receiptLocal?.description,
                            status: setBadgeStatus({
                                type: receiptLocal?.isOpen ? 0 : 1,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            }),
                            balance: separatorsNumbersSet({
                                number: receiptLocal?.balance,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result,
                            from: dateTimeFormatGlobalSet({
                                date: receiptLocal?.from,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            to: dateTimeFormatGlobalSet({
                                date: receiptLocal?.to,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                        };
                        //#endregion variables

                        $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
                            //receiptLocal.number,
                            dataRowObj?.number,
                            //receiptLocal.description,
                            dataRowObj?.description,
                            //setBadgeStatus(receiptLocal.isOpen ? 0 : 1),
                            dataRowObj?.status,
                            //separatorsNumbersSet(receiptLocal.balance).result,
                            dataRowObj?.balance,
                            //dateTimeFormatGlobalSet(receiptLocal.from, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                            dataRowObj?.from,
                            //dateTimeFormatGlobalSet(receiptLocal.to, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                            dataRowObj?.to,
                            buttonProcessGet({
                                id: receiptLocal?.id,
                                description: receiptLocal?.description,
                                showDetails: true,
                                labelDetails: labels?.detail?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: false,
                                labelEdit: labels?.edit?.[languageObj?.id],
                                enabledEdit: false,
                                showDelete: false,
                                labelDelete: labels?.delete?.[languageObj?.id],
                                enabledDelete: false,
                                processButtons: [],
                                subMethod: currentMethod,
                            })?.result,
                        ])?.draw(true);
                        //#endregion add receipt (DataTable)

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const receiptOpenGetAsync = async (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         e?.preventDefault();

    //         if (processType !== 1) {
    //             sendMessage(1, messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id], 0, true, false, null, '');
    //             return;
    //         }

    //         response.msgText = `${messages?.openReceiptMessage?.[languageObj?.id]}<br/>`;
    //         response.msgText += `${labels?.receipt?.[languageObj?.id]}: <b>${receipt.number}</b><br/>`;
    //         response.msgText += `${messages?.doYouWishContinue?.[languageObj?.id]}`;

    //         swalProperties = {
    //             icon: sweetAlert2?.icons?.warning,
    //             title: labels?.warning?.[languageObj?.id],
    //             html: response.msgText,
    //             timer: null,
    //             confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: globalSettings?.colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);
    //         if (isConfirmed) {
    //             receiptOpenAsync();
    //         }

    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: receiptOpenGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //     }
    // }
    //#endregion old code

    const receiptOpenAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'receiptOpenAsync';
        let response = responseGet();
        try {
            //#region old code
            // //#region variables

            // let localReceipt = {};

            // //#endregion variables

            // //#region initialize

            // //#region error default set

            // response = errosDefaultSetAsync();
            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // //#endregion error default set

            // //#region receipt data set

            // response = receiptDataSetAsync();
            // if (!response?.isSuccess || response?.isWarning) {
            //     sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
            //     return;
            // }

            // //#endregion receipt data set

            // //#region form data validate

            // response = formDataValidateAsync();
            // if (!response?.isSuccess || response?.isWarning) {
            //     return;
            // }

            // //#endregion form data validate

            // //#endregion initialize

            // sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            // //#region check if the receipt is closed

            // response = await receiptCheckOpenCloseGetAsync(receipt.id, 0, true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     sendMessage(response.msgType, replaceMessages(0, response.msgText).result, 0, true, false, null, '');
            //     return;
            // }

            // //#endregion check if the receipt is closed

            // //#region updare receipt

            // receipt.isOpen = true;
            // receipt.isClose = false;
            // receipt.isOpenDate = new Date()?.toISOString();

            // headerObj = {
            //     headers: {
            //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //     },
            // };

            // //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt.id}`, receipt, headerObj);
            // result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt.id}`, receipt, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // localReceipt = response.result.receipt;
            // setReceipt(localReceipt);
            // setIsEditabled(true);

            // //#endregion updare receipt

            // //#region add receipt (DataTable)

            // $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
            //     localReceipt.number,
            //     localReceipt.description,
            //     setBadgeStatus(localReceipt.isOpen ? 0 : 1),
            //     separatorsNumbersSet(localReceipt.balance).result,
            //     dateTimeFormatGlobalSet(localReceipt.from, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
            //     dateTimeFormatGlobalSet(localReceipt.to, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
            //     buttonProcessGet(
            //         localReceipt.id,
            //         localReceipt.description,
            //         true,
            //         labels?.detail?.[languageObj?.id],
            //         true,
            //         false,
            //         labels?.edit?.[languageObj?.id],
            //         false,
            //         false,
            //         labels?.delete?.[languageObj?.id],
            //         false,
            //         []
            //     ).result,
            // ])?.draw(true);

            // //#endregion add receipt (DataTable)

            // sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            //#endregion old code

            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region ststuc check
            if (processType !== 1) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion ststuc check

            //#region variables
            let receiptLocal = receiptModelGet({});
            //#endregion variables

            //#region initialize
            //#region error default set
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion error default set

            //#region receipt data set
            response = await receiptDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion receipt data set

            //#region form data validate
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate
            //#endregion initialize

            //#region show message
            let msgTextObj = {
                one: `${messages?.openReceiptMessage?.[languageObj?.id]}<br/>`,
                two: `${labels?.receipt?.[languageObj?.id]}: <b>${receipt?.number}</b><br/>`,
                three: `${labels?.description?.[languageObj?.id]}: <b>${receipt?.description}</b><br/>`,
                four: `${messages?.doYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                //title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                title: labels?.warning?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}${msgTextObj?.four}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                            showConfirmButton: false,
                        });

                        //#region check if the receipt is closed
                        response = await receiptCheckOpenCloseGetAsync({
                            receiptId: receipt?.id,
                            processType: 0,
                            checkStatus: true,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion check if the receipt is closed

                        //#region updare receipt
                        receipt.isOpen = true;
                        receipt.isClose = false;
                        receipt.isOpenDate = new Date()?.toISOString();

                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };
                        dataObj = {
                            languageCode: languageObj?.code,
                            languageId: languageObj?.id,
                            receipt: receipt,
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/${receipt.id}`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        receiptLocal = response?.result?.receipt;
                        setReceipt(receiptLocal);
                        setIsEditabled(true);
                        //#endregion updare receipt

                        //#region add receipt (DataTable)
                        //#region variables
                        const dataRowObj = {
                            number: receiptLocal?.number,
                            description: receiptLocal?.description,
                            status: setBadgeStatus({
                                type: receiptLocal?.isOpen ? 0 : 1,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            }),
                            balance: separatorsNumbersSet({
                                number: receiptLocal?.balance,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result,
                            from: dateTimeFormatGlobalSet({
                                date: receiptLocal?.from,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            to: dateTimeFormatGlobalSet({
                                date: receiptLocal?.to,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                        };
                        //#endregion variables

                        $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
                            //receiptLocal.number,
                            dataRowObj?.number,
                            //receiptLocal.description,
                            dataRowObj?.description,
                            //setBadgeStatus(receiptLocal.isOpen ? 0 : 1),
                            dataRowObj?.status,
                            //separatorsNumbersSet(receiptLocal.balance).result,
                            dataRowObj?.balance,
                            //dateTimeFormatGlobalSet(receiptLocal.from, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                            dataRowObj?.from,
                            //dateTimeFormatGlobalSet(receiptLocal.to, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                            dataRowObj?.to,
                            buttonProcessGet({
                                id: receiptLocal?.id,
                                description: receiptLocal?.description,
                                showDetails: true,
                                labelDetails: labels?.detail?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: false,
                                labelEdit: labels?.edit?.[languageObj?.id],
                                enabledEdit: false,
                                showDelete: false,
                                labelDelete: labels?.delete?.[languageObj?.id],
                                enabledDelete: false,
                                processButtons: [],
                                subMethod: currentMethod,
                            })?.result,
                        ])?.draw(true);
                        //#endregion add receipt (DataTable)

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const receiptCheckOpenCloseGetAsync = async ({
        receiptId = '',
        processType = 0,
        checkStatus = false,
        subMethod = '',
    }) => {
        const currentMethod = 'receiptCheckOpenCloseGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let receiptLocal = receiptModelGet({});
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.isWarning = true;
            responseIsWarning.msgType = 1;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            //#endregion response is warning
            //#endregion variables

            //#region process
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/${receiptId}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            receiptLocal = response?.result?.receipt || {};

            if (checkStatus) {
                switch (processType) {
                    case 0:
                        if (receiptLocal?.isOpen && !receiptLocal?.isClose) {
                            responseIsWarning.msgText += `${messages?.youCanNotOpenAnOpenDocument?.[languageObj?.id]}<br/>`;
                            responseIsWarning.msgText += `${labels?.number?.[languageObj?.id]}: <b>${receiptLocal?.number}</b><br/>`;
                            responseIsWarning.msgText += `${labels?.description?.[languageObj?.id]}: <b>${receiptLocal?.description}</b><br/>`;
                            responseIsWarning.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                            return responseIsWarning;
                        }
                        break;
                    case 1:
                        if (!receiptLocal?.isOpen && receiptLocal?.isClose) {
                            responseIsWarning.msgText += `${messages?.youCanNotCloseAClosedDocument?.[languageObj?.id]}<br/>`;
                            responseIsWarning.msgText += `${labels?.number?.[languageObj?.id]}: <b>${receiptLocal?.number}</b><br/>`;
                            responseIsWarning.msgText += `${labels?.description?.[languageObj?.id]}: <b>${receiptLocal?.description}</b><br/>`;
                            responseIsWarning.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                            return responseIsWarning;
                        }
                        break;
                    default:
                        break;
                }
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //const dateTimeObj?.from = $(`#${controls?.inputs?.dateFrom?.id}`)?.val();
            //const dateTimeObj?.to = $(`#${controls?.inputs?.dateTo?.id}`)?.val();
            //#endregion old code
            const dateTimeObj = {
                from: $(`#${controls?.inputs?.dateFrom?.id}`)?.val(),
                to: $(`#${controls?.inputs?.dateTo?.id}`)?.val(),
                //expenseTemplateDate: $(`#${templateDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: receipt?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dateTimeObj?.from, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: receipt?.from, subMethod: currentMethod, })?.result) {
                setDateFromError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dateTimeObj?.to, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: receipt?.to, subMethod: currentMethod, })?.result) {
                setDateToError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (moment(new Date(receipt?.from).toUTCString()).isSame(new Date(receipt?.to).toUTCString())) {
                setDateFromError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
                setDateToError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (moment(new Date(receipt?.to).toUTCString()).isBefore(new Date(receipt?.from).toUTCString())) {
                setDateFromError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                setDateToError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: expenseTemplate, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: expenseTemplate?.id, subMethod: currentMethod, })?.result) {
                setExpenseTemplateError(messages?.youMustSelectAnExpenseTemplate);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setDateToError('');
            setDateFromError('');
            setDescriptionError('');
            setExpenseTemplateError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const receiptDataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'receiptDataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //const dateTimeObj?.from = $(`#${dateFromId}`)?.datetimepicker('date')?._d;
            //const dateTimeObj?.to = $(`#${dateToId}`)?.datetimepicker('date')?._d;
            //#endregion old code
            const dateTimeObj = {
                from: $(`#${dateFromId}`)?.datetimepicker('date')?._d,
                to: $(`#${dateToId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            receipt.from = !isUndNullEmp({ data: dateTimeObj?.from, subMethod: currentMethod, })?.result ? dateTimeObj?.from : receipt?.from;
            receipt.to = !isUndNullEmp({ data: dateTimeObj?.to, subMethod: currentMethod, })?.result ? dateTimeObj?.to : receipt?.to;

            if (processType === 0) {
                receipt.isOpen = true;
                receipt.isOpenDate = new Date()?.toISOString();
            }
            receipt.balance = !isUndNullEmp({ data: expenseTemplate?.balance, subMethod: currentMethod, })?.result ? expenseTemplate?.balance : neutralValue;
            receipt.total = !isUndNullEmp({ data: expenseTemplate?.balance, subMethod: currentMethod, })?.result ? expenseTemplate?.balance : neutralValue;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dateErrosSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dateErrosSetAsync';
        let response = responseGet();
        try {
            setDateToError('');
            setDateFromError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion receipt (methods)

    //#region expenseTemplate (methods)
    const templateAddGetAsync = async ({
        e = {},
        subMethod = '', }) => {
        const currentMethod = 'templateAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let isDisableLocal = false;
            let buildingIdLocal = $(`#${buildingsId}`)?.val();
            let templatesLocal = [expenseTemplateModelGet({})];
            //#endregion variables

            //#region Previus data
            if (isEditDelete) {
                return;
            }

            isDisableLocal = (processType === -1 || receipt.isClose);
            //#endregion Previus data

            //#region data check
            if (isDisableLocal) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.thisProcessAppliesOnlyToNewOrCreatedRecords?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion data check

            //#region methods
            setExpenseTemplates([]);
            setExpenseTemplatesDt([]);
            setExpenseTemplateError('');

            if (processType !== -1) {
                //#region data check
                if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion data check

                controlsStatusSet({ processType: 1, subMethod: currentMethod, });

                response = await validationExpenseTemplateGetAsync({
                    buildingId: buildingIdLocal,
                    auth: auth,
                    limit: 0,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                templatesLocal = response?.result || [];

                response.result = [];

                templatesLocal?.forEach((detail) => {
                    let checkBoxHtml = `<div class='custom-control custom-radio' for='${detail?.id}'>`;
                    checkBoxHtml += `  <input class='custom-control-input' type='radio' name='expenseTemplateAdd' description='${detail?.description}' id='${detail?.id}' />`;
                    checkBoxHtml += `  <label class='custom-control-label' for='${detail?.id}'></label>`
                    checkBoxHtml += `</div>`

                    response.result.push([
                        dateTimeFormatGlobalSet({
                            date: detail?.date,
                            type: reactHtml?.tempusDominus?.format?.date?.ymdTwo,
                            format: 0,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        detail.description,
                        //dateTimeFormatGlobalSet(detail.date, reactHtml?.tempusDominus?.format?.date?.dmy, 0, false).result,
                        dateTimeFormatGlobalSet({
                            date: detail?.date,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        separatorsNumbersSet({
                            number: detail?.balance,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        checkBoxHtml,
                    ]);
                });

                setExpenseTemplates(templatesLocal);
                setExpenseTemplatesDt(response?.result);

                setExpenseTemplateAddShowModal(true);
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.thisProcessAppliesOnlyToNewOrCreatedRecords?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion methods
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion expenseTemplate (methods)

    //#region receipts (methods)
    const receiptsVariationsGetAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'receiptsVariationsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let receiptsVariationsLocal = [{
                ...receiptModelGet({}),
                price: neutralValue,
                details: {
                    price: neutralValue,
                },
                percentage: neutralValue,
            }];
            const buildingIdLocal = building?.id || '';
            //#endregion variables

            controlsStatusSet({ processType: 6, subMethod: currentMethod, });

            //#region receipt cariations get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                buildingId: buildingIdLocal,
                languageCode: languageObj?.code,
                languageId: languageObj?.id,
                method: backend?.methods?.variationsGet,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReceipts}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            receiptsVariationsLocal = response?.result || [];

            setReceiptsVariations(receiptsVariationsLocal);
            //#endregion updare receipt

            setReceiptsVariationsShowModal(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion receipts (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, receipts: true, receipt: true, });

            //#region initialize
            //#endregion initialize

            //#region dateTime in control set
            response = await dateInControlSetAsync({
                date: new Date(),
                receiptDateFrom: undefined,
                receiptDateTo: undefined,
                processType: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, });
                return;
            }
            //#endregion dateTime in control set

            //#region dataTable set / clear datatabla / set query code
            response = await dataTableReceiptsSetAsync({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, });
                return
            }

            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, });
                return
            }
            //#endregion dataTable set / clear datatabla / set query code

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlExpenseTemplates,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result &&
                response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings || []);
            }
            //#endregion buildings get

            setShowLoading({ building: false, receipts: false, receipt: false, });
        } catch (ex) {
            setShowLoading({ building: false, receipts: false, receipt: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtReceiptsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtReceiptsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            receiptEditGetAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region old code
    // const localDataTablesClear = (clearDtTemplates = false) => {
    //     let response = responseGet();
    //     try {
    //         if (clearDtTemplates) {
    //             $(`#${dtReceiptsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localDataTablesClear<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const dateInControlSetAsync = async ({
        date = new Date(),
        receiptDateFrom = undefined,
        receiptDateTo = undefined,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //const dateTimeObj?.format = reactHtml?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = reactHtml?.tempusDominus?.format?.date?.DDMMYYYY;
            //let dateTimeObj?.from = '';
            //let dateTimeObj?.to = '';
            //#endregion old code
            const dateTimeObj = {
                from: '',
                to: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: receiptDateFrom, subMethod: currentMethod, })?.result) {
                dateTimeObj.from = dateTimeFormatGlobalSet({
                    date: receiptDateFrom,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.from = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (!isUndNullEmp({ data: receiptDateTo, subMethod: currentMethod, })?.result) {
                dateTimeObj.to = dateTimeFormatGlobalSet({
                    date: receiptDateTo,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.to = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (processType === 0) {
                $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                    icons: reactHtml?.tempusDominus?.icons,
                    buttons: reactHtml?.tempusDominus?.buttons,
                    tooltips: reactHtml?.tempusDominus?.tooltips,
                    locale: languageObj?.id,
                });

                $(`#${dateFromId}`)?.datetimepicker({
                    date: moment(`${dateTimeObj?.from}`, dateTimeObj?.formatTwo),
                    default: false,
                    format: `${dateTimeObj?.formatTwo}`,
                });

                $(`#${dateToId}`)?.datetimepicker({
                    date: moment(`${dateTimeObj?.to}`, dateTimeObj?.formatTwo),
                    //date: moment(`${localDateTo}`, localDateFormatTwo).endOf('month'),
                    default: false,
                    format: `${dateTimeObj?.formatTwo}`,
                });

                //$(`#${dateFromId}`)?.datetimepicker('date', moment(`${localDateTo}`, localDateFormatTwo));
                $(`#${dateFromId}`)?.datetimepicker('date', moment(`${dateTimeObj?.to}`, dateTimeObj?.formatTwo)?.startOf('month'));
                $(`#${dateToId}`)?.datetimepicker('date', moment(`${dateTimeObj?.to}`, dateTimeObj?.formatTwo)?.endOf('month'));
            } else if (processType === 1) {
                if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result &&
                    isUndNullEmp({ data: receiptDateFrom, subMethod: currentMethod, })?.result &&
                    isUndNullEmp({ data: receiptDateTo, subMethod: currentMethod, })?.result) {
                    $(`#${dateFromId}`)?.datetimepicker('date', moment(`${dateTimeObj?.to}`, dateTimeObj?.formatTwo)?.startOf('month'));
                    $(`#${dateToId}`)?.datetimepicker('date', moment(`${dateTimeObj?.to}`, dateTimeObj?.formatTwo)?.endOf('month'));
                } else {
                    $(`#${dateFromId}`)?.datetimepicker('date', moment(`${dateTimeObj?.from}`, dateTimeObj?.formatTwo));
                    $(`#${dateToId}`)?.datetimepicker('date', moment(`${dateTimeObj?.to}`, dateTimeObj?.formatTwo));
                }
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    $(`#${controls?.icons?.expenseTemplateAdd?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.expenseTemplateAdd?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.new?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.new?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.icons?.open?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.open?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 5:
                    $(`#${controls?.icons?.close?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.close?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 6:
                    $(`#${controls?.icons?.variations?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.variations?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            $(`#${controls?.inputs?.number?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.description?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.dateFrom?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.dateTo?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.expenseTemplateDescription?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.expenseTemplateBalance?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.apartmentReceiptDetailsBalance?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : reactHtmlreCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.receipts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.receipts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.expenseTemplateAdd?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.new?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.open?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.delete?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.variations?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='receipts' process='generate' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.generateReceipts?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.generateReceipts?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {/*buildings*/}
                        <BuildingHeader buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={receiptsSyncDisabled}
                            methodGetAsync={receiptsGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.building}
                            languageObj={languageObj} />

                        {/* {!showLoading ? */}
                        {/* <div> */}
                        {/* {showData ? */}
                        {/* <div> */}
                        <div className='row'>

                            {/*receipts (generateds) */}
                            <div className='col-md-8'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.receipts}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />
                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.receipts?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.receiptsLogo}></img> - {labels?.receipts?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtReceiptsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>

                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    <div className='card-footer'>
                                        <div className='form-group text-right'>
                                            <button id={controls?.buttons?.variations?.id}
                                                className={controls?.buttons?.variations?.className}
                                                disabled={isUndNullEmp({ data: building?.id, subMethod: controls?.buttons?.variations?.id, })?.result}
                                                onClick={(e) => receiptsVariationsGetAsync({ e: e, subMethod: controls?.buttons?.variations?.id, })}
                                                tooltip='tooltip'
                                                title={labels?.variation?.[languageObj?.id]}
                                                type='button'>
                                                <i id={controls?.icons?.variations?.id}
                                                    className={controls?.icons?.variations?.className} /> <span id={controls?.spinners?.variations?.id} className='' aria-hidden='true'></span>
                                            </button>
                                        </div>
                                    </div>

                                </div>{/*card*/}
                            </div>{/*col*/}

                            {/*receipt (create)*/}
                            <div className='col-md-4'>
                                <form onSubmit={(e) => processType === 0 ?
                                    receiptAddPostAsync({ e: e, subMethod: 'form - onSubmit', }) :
                                    receiptEditPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                                    <div className='card card-outline card-primary shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={reactHtml?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.receipt}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />
                                        {/*header*/}
                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={labels?.receipt?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.receiptLogo}></img>
                                                - {labels?.receipt?.[languageObj?.id]} {processType === 0
                                                    ? `(${labels?.create?.[languageObj?.id]?.toLowerCase()})` : processType === 1 ?
                                                        (!isEditDelete ? `(${labels?.edit?.[languageObj?.id]?.toLowerCase()})` : `(${labels?.detail?.[languageObj?.id]?.toLowerCase()})`) : ''}
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div> {/*card header*/}

                                        {/*body*/}
                                        <div className='card-body'>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.number?.id}
                                                                className={controls?.inputs?.number?.className}
                                                                placeholder={labels?.number?.[languageObj?.id]}
                                                                readOnly
                                                                tooltip='tooltip'
                                                                title={labels?.number?.[languageObj?.id]}
                                                                value={receipt.number || ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.fileInvoice} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div> */}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <ul className='list-unstyled text-muted'>
                                                            <li>{labels?.status?.[languageObj?.id]}: {
                                                                HtmlParser(
                                                                    setBadgeStatus({
                                                                        type: processType === -1 ?
                                                                            2 :
                                                                            receipt.number > 0 ?
                                                                                receipt.isOpen ?
                                                                                    0 :
                                                                                    1 :
                                                                                -1,
                                                                        languageId: languageObj?.id,
                                                                        subMethod: 'lbl - receiptStatus',
                                                                    })
                                                                )
                                                            }
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.description?.id}
                                                                className={controls?.inputs?.description?.className}
                                                                //autoFocus
                                                                //disabled={processType === -1 || !isEditabled || isEditDelete}
                                                                onChange={(e) => formDataSetAsync({
                                                                    property: dbProps?.description,
                                                                    value: e?.target?.value,
                                                                    subMethod: 'input - receiptDescription',
                                                                })}
                                                                onFocus={() => setDescriptionError('')}
                                                                placeholder={labels?.description?.[languageObj?.id]}
                                                                readOnly={processType === -1 || !isEditabled || isEditDelete}
                                                                tooltip='tooltip'
                                                                title={labels?.description?.[languageObj?.id]}
                                                                value={receipt?.description || ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.spellCheck} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        {/* <DatePicker /> */}
                                                        <div className='input-group mb-3'>
                                                            <div id={dateFromId}
                                                                className='input-group date'
                                                                data-target-input='nearest'>
                                                                <input id={controls?.inputs?.dateFrom?.id}
                                                                    className={controls?.inputs?.dateFrom?.className}
                                                                    //id={receiptFromInputId}
                                                                    //className='form-control bg-transparent text-black datetimepicker-input'
                                                                    data-target={`#${dateFromId}`}
                                                                    data-toggle='datetimepicker'
                                                                    disabled={processType === -1 || !isEditabled || isEditDelete}
                                                                    onFocus={() => dateErrosSetAsync({ subMethod: 'input - receiptFrom' })}
                                                                    placeholder={labels?.from?.[languageObj?.id]}
                                                                    //readOnly={processType === -1 || !isEditabled || isEditDelete}
                                                                    tooltip='tooltip'
                                                                    title={labels?.from?.[languageObj?.id]}
                                                                    type='text' />
                                                                <div className='input-group-append'
                                                                    data-target={`#${dateFromId}`}
                                                                    data-toggle='datetimepicker'>
                                                                    <div className='input-group-text'>
                                                                        <i className={icons?.calendarAlt}></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateFromError)}</div>
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        {/* <DatePicker /> */}
                                                        <div className='input-group mb-3'>
                                                            <div id={dateToId}
                                                                className='input-group date'
                                                                data-target-input='nearest'>
                                                                <input id={controls?.inputs?.dateTo?.id}
                                                                    className={controls?.inputs?.dateTo?.className}
                                                                    //id={receiptToInputId}
                                                                    //className='form-control bg-transparent text-black datetimepicker-input'
                                                                    data-target={`#${dateToId}`}
                                                                    data-toggle='datetimepicker'
                                                                    disabled={processType === -1 || !isEditabled || isEditDelete}
                                                                    onFocus={() => dateErrosSetAsync({ subMethod: 'input - receiptTo' })}
                                                                    placeholder={labels?.to?.[languageObj?.id]}
                                                                    //readOnly={processType === -1 || !isEditabled || isEditDelete}
                                                                    tooltip='tooltip'
                                                                    title={labels?.to?.[languageObj?.id]}
                                                                    type='text' />
                                                                <div className='input-group-append'
                                                                    data-target={`#${dateToId}`}
                                                                    data-toggle='datetimepicker'>
                                                                    <div className='input-group-text'>
                                                                        <i className={icons?.calendarAlt}></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateToError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.expenseTemplateDescription?.id}
                                                                className={controls?.inputs?.expenseTemplateDescription?.className}
                                                                //className='form-control bg-transparent text-black'
                                                                readOnly
                                                                placeholder={labels?.expenseTemplate?.[languageObj?.id]}
                                                                tooltip='tooltip'
                                                                title={labels?.expenseTemplate?.[languageObj?.id]}
                                                                value={expenseTemplate?.description || ''} />
                                                            <div className='input-group-append'>
                                                                <div id={controls?.buttons?.close?.id}
                                                                    className='btn btn-outline-success'
                                                                    onClick={(e) => templateAddGetAsync({ e: e, subMethod: 'btn - expenseTemplateAdd', })}
                                                                    tooltip='tooltip'
                                                                    title={labels?.findExpenseTemplate}>
                                                                    {/* <span className={icons?.search} /> */}
                                                                    <i id={controls?.icons?.expenseTemplateAdd?.id} className={controls?.icons?.expenseTemplateAdd?.className} /> <span id={controls?.spinners?.expenseTemplateAdd?.id} className='' aria-hidden='true'></span>
                                                                </div>
                                                            </div>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-window-restore' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(expenseTemplateError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.expenseTemplateBalance?.id}
                                                                className={controls?.inputs?.expenseTemplateBalance?.className}
                                                                //className='form-control bg-transparent text-black text-right'
                                                                readOnly
                                                                placeholder={labels?.totalExpenseTemplate?.[languageObj?.id]}
                                                                tooltip='tooltip'
                                                                title={labels?.totalExpenseTemplate?.[languageObj?.id]}
                                                                value={separatorsNumbersSet({
                                                                    number: expenseTemplate?.balance || neutralValue,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'input - expenseTemplateTotal',
                                                                })?.result} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.moneyBillWave} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.apartmentReceiptDetailsBalance?.id}
                                                                className={controls?.inputs?.apartmentReceiptDetailsBalance?.className}
                                                                //className='form-control bg-transparent text-black text-right'
                                                                readOnly
                                                                placeholder={labels?.receiptDetails?.[languageObj?.id]}
                                                                tooltip='tooltip'
                                                                title={labels?.receiptDetails?.[languageObj?.id]}
                                                                value={separatorsNumbersSet({
                                                                    number: apartmentReceiptDetailsBalance || neutralValue,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'input - apartmentreceipDetailsBalance',
                                                                })?.result} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.listTh} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> {/*card body*/}

                                        {/*footer*/}
                                        <div className='card-footer'>
                                            <div className='form-group text-right'>
                                                <button id={controls?.buttons?.save?.id}
                                                    className={controls?.buttons?.save?.className}
                                                    disabled={processType === -1 || receipt.isClose || isEditDelete}
                                                    tooltip='tooltip'
                                                    title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                                    type='submit'>
                                                    <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.new?.id}
                                                    className={controls?.buttons?.new?.className}
                                                    disabled={processType === -1 || processType === 0 || isEditDelete}
                                                    onClick={(e) => receiptAddGetAsync({ e: e, subMethod: 'btn - receiptNew', })}
                                                    tooltip='tooltip'
                                                    title={labels?.new?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.new?.id} className={controls?.icons?.new?.className} /> <span id={controls?.spinners?.new?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.open?.id}
                                                    className={controls?.buttons?.open?.className}
                                                    disabled={processType === -1 || processType === 0 || receipt.isOpen || isEditDelete}
                                                    onClick={(e) => receiptOpenAsync({ e: e, subMethod: 'btn - receiptOpen', })}
                                                    tooltip='tooltip'
                                                    title={labels?.open?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.open?.id} className={controls?.icons?.open?.className} /> <span id={controls?.spinners?.open?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.close?.id}
                                                    className={controls?.buttons?.close?.className}
                                                    disabled={processType === -1 || processType === 0 || receipt.isClose || isEditDelete}
                                                    onClick={(e) => receiptCloseAsync({ e: e, subMethod: 'btn - receiptClose', })}
                                                    tooltip='tooltip'
                                                    title={labels?.close?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.close?.id} className={controls?.icons?.close?.className} /> <span id={controls?.spinners?.close?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.delete?.id}
                                                    className={controls?.buttons?.delete?.className}
                                                    disabled={processType !== 1 || isEditDelete}
                                                    tooltip='tooltip'
                                                    title={labels?.delete?.[languageObj?.id]}
                                                    onClick={(e) => receiptDeleteAsync({ e: e, subMethod: 'btn - receiptDelete', })}
                                                    type='button'>
                                                    <i id={controls?.icons?.delete?.id} className={controls?.icons?.delete?.className} /> <span id={controls?.spinners?.delete?.id} className='' aria-hidden='true'></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>{/*card*/}
                                </form>
                            </div>{/*col*/}

                        </div>{/*row*/}
                        {/* </div> */}
                        {/* : */}
                        {/* <div></div> */}
                        {/* } */}
                        {/* </div> */}
                        {/* : */}
                        {/* <CssfxLoading type={reactHtmlCssfxLoading?.circularProgress}
                                width={40}
                                height={40}
                                color={globalSettings?.colors?.infoColorExp}
                                msgText={messages?.processing?.[languageObj?.id]}
                                msgOrientation='text-center'
                                msgTextMuted={true} /> */}
                        {/* } */}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {expenseTemplateAddShowModal ?
                <ExpenseTemplateAdd $={$}
                    auth={auth}
                    expenseTemplatesDt={expenseTemplatesDt}
                    expenseTemplates={expenseTemplates}
                    // expenseTemplate={expenseTemplate}
                    setExpenseTemplate={setExpenseTemplate}
                    receipt={receipt}
                    setReceipt={setReceipt}
                    showModal={expenseTemplateAddShowModal}
                    setShowModal={setExpenseTemplateAddShowModal}
                    processType={processType} />
                :
                <></>
            }

            {receiptsVariationsShowModal ?
                <ReceiptsVariations $={$}
                    auth={auth}
                    building={building}
                    receiptsVariations={receiptsVariations}
                    showModal={receiptsVariationsShowModal}
                    setShowModal={setReceiptsVariationsShowModal}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}